import React from "react";
import Spline from "@splinetool/react-spline";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      {/* Spline scene background (optimized for performance) */}
      {/*   <div
        style={{
          position: "absolute",
          inset: "-50px 0 0 0",
          zIndex: 0,
          width: "100%",
          height: "calc(100% + 100px)",
          transform: "scale(0.8)",
          transformOrigin: "center center",
        }}
      >
        <Spline
          scene="https://prod.spline.design/rpfAFLfg9JrwQIKu/scene.splinecode"
          style={{ width: "100%", height: "100%" }}
        />
      </div> */}
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-main">
            {/* Company Info */}
            <div className="footer-company">
              <div className="footer-logo">
                <img src="/icons/logo-dark.svg" alt="Nestia Logo" />
              </div>
              <p className="footer-description">
                Nestia est une agence digitale qui accompagne startups et
                entreprises dans la création d'expériences uniques : branding,
                design UI/UX, développement web et mobile. Notre mission :
                transformer vos idées en produits solides, élégants et durables.
              </p>

              {/* Social Links */}
              <div className="social-links">
                <a
                  href="https://www.linkedin.com/company/nestia-group/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="LinkedIn"
                >
                  <img src="/icons/linkedin.svg" alt="LinkedIn" />
                </a>
                <a
                  href="https://x.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Twitter/X"
                >
                  <img src="/icons/x.svg" alt="X" />
                </a>
                <a
                  href="https://www.instagram.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Instagram"
                >
                  <img src="/icons/instagram.svg" alt="Instagram" />
                </a>
                <a
                  href="https://www.facebook.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Facebook"
                >
                  <img src="/icons/facebook.svg" alt="Facebook" />
                </a>
              </div>
            </div>

            {/* Navigation Links */}
            <div className="footer-nav">
              <div className="footer-nav-section">
                <h3 className="footer-nav-title">Nestia</h3>
                <ul className="footer-nav-list">
                  <li>
                    <a href="#about">à propos</a>
                  </li>
                  <li>
                    <a href="#partners">Partenaires</a>
                  </li>
                  <li>
                    <a href="#services">Services</a>
                  </li>
                  <li>
                    <a href="#process">Process</a>
                  </li>
                </ul>
              </div>

              <div className="footer-nav-section">
                <h3 className="footer-nav-title">Contact</h3>
                <div className="contact-info">
                  <div className="contact-item">
                    <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.5379 5.31622L11.1869 6.47922C11.7719 7.52922 11.5369 8.90522 10.6149 9.82822C10.6149 9.82822 9.4949 10.9472 11.5249 12.9762C13.5519 15.0032 14.6719 13.8862 14.6719 13.8862C15.5949 12.9632 16.9719 12.7282 18.0209 13.3132L19.1839 13.9632C20.7689 14.8472 20.9559 17.0692 19.5629 18.4632C18.7259 19.2992 17.6999 19.9512 16.5669 19.9932C14.6589 20.0662 11.4179 19.5832 8.1669 16.3332C4.9169 13.0822 4.4339 9.84122 4.5069 7.93322C4.5499 6.80022 5.20091 5.77422 6.03691 4.93722C7.43091 3.54422 9.6529 3.73122 10.5369 5.31722"
                        fill="white"
                      />
                    </svg>
                    <span>+33 783208448</span>
                  </div>
                  <div className="contact-item">
                    <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.5"
                        d="M2.5 11.25C2.5 8.35 4.515 6 7 6C9.485 6 11.5 8.35 11.5 11.25V20H4.733C3.5 20 2.5 18.834 2.5 17.395V11.25Z"
                        fill="white"
                      />
                      <path
                        opacity="0.8"
                        d="M11.5 11.25V20H20.293C21.512 20 22.5 18.847 22.5 17.425V11.25C22.5 8.35 20.485 6 18 6H7C9.485 6 11.5 8.35 11.5 11.25Z"
                        fill="white"
                      />
                      <path
                        d="M10 20V22C10 22.1989 10.079 22.3897 10.2197 22.5303C10.3603 22.671 10.5511 22.75 10.75 22.75C10.9489 22.75 11.1397 22.671 11.2803 22.5303C11.421 22.3897 11.5 22.1989 11.5 22V20H10ZM15.5 20H14V22C14 22.1989 14.079 22.3897 14.2197 22.5303C14.3603 22.671 14.5511 22.75 14.75 22.75C14.9489 22.75 15.1397 22.671 15.2803 22.5303C15.421 22.3897 15.5 22.1989 15.5 22V20Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.75 16C4.75 15.801 4.82902 15.6103 4.96967 15.4696C5.11032 15.329 5.30109 15.25 5.5 15.25H8.5C8.69891 15.25 8.88968 15.329 9.03033 15.4696C9.17098 15.6103 9.25 15.801 9.25 16C9.25 16.1989 9.17098 16.3896 9.03033 16.5303C8.88968 16.6709 8.69891 16.75 8.5 16.75H5.5C5.30109 16.75 5.11032 16.6709 4.96967 16.5303C4.82902 16.3896 4.75 16.1989 4.75 16Z"
                        fill="white"
                      />
                    </svg>
                    <span>contact@nest-ia.com</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="footer-divider"></div>

          {/* Copyright */}
          <div className="footer-copyright">
            <p>© {new Date().getFullYear()} Nestia. Tous droits réservés.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
